export enum MESSAGE_ERROR {
  M01 = 'Invalid email and password.',
  M02 = 'An error occurred. Please try again later.',
  M03 = 'An error get images from server. Please try again later.',
}
